import React, { PureComponent, Fragment } from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Line,
} from "recharts";
import {
  selectFormat,
  Error,
  StandardTooltip,
  CustomizedYAxisTick,
  CustomizedYAxisTickRightPercent,
  CustomizedXAxisTickTime,
  formatDateFromData,
} from "components/Utils/Utils.js";

class FreeTrialEnders extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const widget_data = data.data;
    const preparedData = formatDateFromData(widget_data, "YYYY/MM/DD");

    return (
      <div className="row mt-2 d-flex align-items-end">
        <div className="col-12 mt-4">
          <ResponsiveContainer height={300} width="100%">
            <ComposedChart
              width={150}
              height={320}
              data={preparedData}
              margin={{
                top: 0,
                right: 0,
                left: -38,
                bottom: 0,
              }}
            >
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      let payload = data(this.props);
                      if (payload !== null) {
                        // always get the first element
                        payload = payload[0];
                        return (
                          <div className="standard-tooltip">
                            <Fragment>
                              <header className="standard-tooltip__header">
                                <span className="standard-tooltip__value-header">
                                  {payload.payload.date}
                                </span>
                              </header>

                              <main className="standard-tooltip__main">
                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#FA6E58" }}
                                    ></span>
                                    Enders Monthly
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "number",
                                      payload.payload.free_trial_enders_monthly
                                    )}
                                  </span>
                                </div>

                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#2AC8DD" }}
                                    ></span>
                                    Enders Annual
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "number",
                                      payload.payload.free_trial_enders_annual
                                    )}
                                  </span>
                                </div>

                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#868E96" }}
                                    ></span>
                                    Conv Rate Monthly
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "percent",
                                      payload.payload
                                        .free_trial_conversion_rate_monthly,
                                      "0.0%"
                                    )}
                                  </span>
                                </div>

                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#000" }}
                                    ></span>
                                    Conv Rate Annual
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "percent",
                                      payload.payload
                                        .free_trial_conversion_rate_annual,
                                      "0.0%"
                                    )}
                                  </span>
                                </div>
                              </main>
                            </Fragment>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />

              <Bar
                stackId="stack"
                dataKey="free_trial_enders_annual"
                fillOpacity={1}
                fill="#2AC8DD"
              />

              <Bar
                stackId="stack"
                dataKey="free_trial_enders_monthly"
                fillOpacity={1}
                fill="#FA6E58"
              />

              <XAxis
                dataKey="date"
                axisLine={false}
                tickLine={true}
                tick={<CustomizedXAxisTickTime />}
              />

              <YAxis
                axisLine={false}
                tickLine={false}
                tickFormatter={(d) => selectFormat("number", d)}
                tick={<CustomizedYAxisTick />}
              />

              <YAxis
                yAxisId="right"
                axisLine={false}
                tickLine={false}
                tick={<CustomizedYAxisTickRightPercent />}
                orientation="right"
              />

              <Line
                yAxisId="right"
                dataKey="free_trial_conversion_rate_annual"
                stroke="#000"
                type="monotone"
                strokeWidth={1}
                dot={false}
                cursor="pointer"
              />

              <Line
                yAxisId="right"
                dataKey="free_trial_conversion_rate_monthly"
                stroke="#868E96"
                type="monotone"
                strokeWidth={1}
                dot={false}
                cursor="pointer"
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default FreeTrialEnders;
